import { render, staticRenderFns } from "./ChatInfo.vue?vue&type=template&id=0017393d&scoped=true&"
import script from "./ChatInfo.vue?vue&type=script&lang=js&"
export * from "./ChatInfo.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfo.vue?vue&type=style&index=0&id=0017393d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017393d",
  null
  
)

export default component.exports